import {useFluxStore} from 'client/framework';
import sessionStore from 'client/Session/SessionStore';
import {useCanViewAnnotations} from 'client/components/PracticeView/Annotations/mode/useCanViewAnnotations';

/** `/learn` has no session guard, so teachers, authors and visitors share this view. */
export function useIsSubjectPracticeAnnotationAvailable(): boolean {
  const canViewAnnotations = useCanViewAnnotations();
  const isStudent = useFluxStore(sessionStore, (store) => store.isStudent());

  return canViewAnnotations && isStudent;
}
